'use strict';

const visualElementStore = new WeakMap();

exports.visualElementStore = visualElementStore;
//# sourceMappingURL=store.cjs.map
